import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { getCollectionSetsForSection, sectionHasQuestions } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { CIPXQuoteRequestIntakeForm, CIPXQuoteRequestIntakeFormStateBondAdditionalQuestionSet } from '../../../../intake-form.types';
import { CIPXQuoteRequestIntakeFormQuestionSetComponent } from '../../../../question-set/question-set.component';
import { CIPXQuoteRequestIntakeFormQuestionCollectionComponent } from '../../../../question-collection/question-collection.component';
import { MaterialModule } from '@sbd-doug-frontend/app/shared/material.module';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedComponentsModule,
    CIPXQuoteRequestIntakeFormQuestionSetComponent,
    CIPXQuoteRequestIntakeFormQuestionCollectionComponent
  ],
  selector: 'cipx-quote-request-intake-form-request-details-screen-and-explain',
  templateUrl: 'screen-and-explain.component.html'
})

export class CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent {

  private _intakeService = inject(CIPXQuoteRequestIntakeFormService);
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  selectedStateBond = this._intakeService.selectedStateBond;
  sectionHasQuestions = sectionHasQuestions;

  sections = [
    { name: 'project_information', title: 'Project Information' },
    { name: 'screening', title: 'Quick Questions' },
    { name: 'probate', title: 'Probate Court Information' },
  ];

  collectionSetsBySection = computed<Record<string, CIPXQuoteRequestIntakeFormStateBondAdditionalQuestionSet[]>>(() => {
    const stateBond = this.selectedStateBond();
    if (!stateBond) {
      return {};
    }
    return Object.fromEntries(
      this.sections.map(section => [section.name, getCollectionSetsForSection(section.name, stateBond)])
    );
  });
}
